<template>
  <v-container fluid>
    <h2 class="mb-4">Мои пополнения</h2>

    <div>
        <label>По договору</label>
        <CustomSelect 
          v-model="investmentGuid"
          @selected="investmentGuid=$event; fetchInvestments()"
        >
          <option 
            v-for="deal in deals" 
            :value="deal.guid"
            :key="deal.guid"
          >
           {{ deal.contractNumber }}
          </option>
      </CustomSelect>
    </div>

    <div v-if="isLoading" class="text-center my-4">
      Загрузка...
    </div>

    <div v-else class="rounded-lg table-container mt-8">
      <v-table>
        <tbody>
        <tr 
          class="border-0"
          v-for="(investment, index) in investments"
          :key="index"
        >
          <td class="text-no-wrap px-1 text-caption text-sm-body-1 text-center">            
            {{ $formatDate(investment.date) }}
          </td>
          <td class="text-center px-1 text-caption text-sm-body-1">
            {{ investment.transactionType }}
          </td>
          <td class="text-green px-1 text-caption text-sm-body-1 text-center">
            {{ $formatNumber(investment.amount) }}
          </td>
        </tr>
        </tbody>
      </v-table>
    </div>
  </v-container>    
</template>

<script>
import CustomSelect from '@/components/CustomSelect.vue';
import axios from 'axios';
import { BACKEND_API_ENDPOINT } from "@/api";
import { jwtDecoded } from "@/helpers";

axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('jwtToken')}`;

export default {
  components: {
    CustomSelect,
  },
  data() {
    return {
      investmentGuid: '',
      isLoading: true,
      deals: [],
      investments: [],
    }
  },
  created() {
    const fetchData = async () => {
      try {
        const dealsResponse = await axios.get(BACKEND_API_ENDPOINT + '/retrieve_deals', {
          params: {
            phone_number: this.parsePhoneNumberFromJwt()
          }
        });

        this.deals = dealsResponse.data.Result.deals.map(deal => ({
          guid: deal.guid,
          contractNumber: deal.contractNumber
        }));

        const investmentsResponse = await axios.get(BACKEND_API_ENDPOINT + '/investment_history', {
          params: {
            investmentGuid: this.deals[0].guid
          }
        });

        this.investments = investmentsResponse.data.Result.investmentHistory;        

        this.isLoading = false;
      } catch (error) {
        console.error('Error fetching data:', error);
        this.isLoading = false; 
      }
    };

    fetchData();
  },
  methods: {
    parsePhoneNumberFromJwt() {
      const payload = jwtDecoded();

      if (payload) {
        return payload.userUUID.replace('+996', '')
      }

      return
    },
    async fetchInvestments() {
      this.isLoading = true;

      try {
        const response = await axios.get(
          BACKEND_API_ENDPOINT + '/investment_history', {
            params: {
              investmentGuid: this.investmentGuid
            }
          }
        );

        this.investments = response.data.Result.investmentHistory;
      } catch (error) {
        console.error('Error fetching payments:', error);
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>

<style scoped>
.table-container {
  max-height: 470px; overflow-y: auto;
}

.table-container::-webkit-scrollbar {
  width: 4px;
}

.table-container::-webkit-scrollbar-thumb {
  background-color: rgba(113, 182, 70, 0.5);
  border-radius: 3px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background-color: #07a01d;
}
</style>